module.exports = __webpack_public_path__ + "static/media/empty.887913fe.svg";